import { useParams } from "react-router-dom";
import SavePreventaCoperativo from "../../shared/save_preventa_coperativo/SavePreventaCorporativa";
import { LoaderComponent } from "@/shared/components/ui";
import {  useGetProspectoByIdProspectoCorporativo } from "@/shared/actions/erp/prospecto_corporativo.actions";

export default function CreatePreventaCorporativo() {
  const { idprospecto } = useParams();

  const { data, isLoading } = useGetProspectoByIdProspectoCorporativo(idprospecto!);

  if (isLoading) return <LoaderComponent />

  if (!!!data) return null;

  return (
    <SavePreventaCoperativo
      title="Crear Oportunidad Comercial"
      dataProspecto={data}
      enableEdit={true}
    />
  )

}